<div class="dynamic-extension">
  <div class="content">
    @if (initialized) {
      <pdq-card variant="popover" color="white">
        <div class="card-title"><pdq-heading element="h5">Token for Shopify</pdq-heading></div>
        <pdq-divider></pdq-divider>
        <div class="controls-wrapper">
          <pdq-input
            [disabled]="true"
            [formControl]="usageTokenControl"
            label="Copy & paste this into Shopify's components by this extension's token"
            [clipboard]="true"></pdq-input>
          <pdq-extension-preview-token [usageTokenControl]="usageTokenControl"></pdq-extension-preview-token>
        </div>
      </pdq-card>

      @if (hasEditableFields) {
        <form [formGroup]="formGroup">
          <pdq-card variant="popover" color="white">
            <div class="card-title"><pdq-heading element="h5">Settings</pdq-heading></div>
            <pdq-divider></pdq-divider>
            <div class="controls-wrapper">
              @for (field of fields; track field.key) {
                <div class="field">
                  @switch (field.controlType) {
                    @case (controlType.TEXT) {
                      <pdq-input
                        [formControlName]="field.key"
                        [label]="field.label"
                        [required]="field.required"></pdq-input>
                    }
                    @case (controlType.NUMBER) {
                      <pdq-input
                        type="number"
                        [formControlName]="field.key"
                        [label]="field.label"
                        [required]="field.required"></pdq-input>
                    }
                    @case (controlType.TOGGLE) {
                      <pdq-slide-toggle
                        [formControlName]="field.key"
                        [label]="field.label"
                        [subtext]="field.description ?? ''"></pdq-slide-toggle>
                    }
                    @case (controlType.SELECT) {
                      <pdq-dropdown
                        [formControlName]="field.key"
                        [title]="field.label"
                        [options]="field.options"
                        [fullWidth]="true"></pdq-dropdown>
                    }
                    @default {
                      <div class="unsupported-field">
                        <span class="field-label body-14-medium">{{ field.label }}</span>
                        <pdq-banner
                          variant="attention"
                          [closable]="false"
                          content="This setting type can't be edited here. Use Cowork to change it."></pdq-banner>
                      </div>
                    }
                  }
                  @if (field.description && field.controlType !== controlType.TOGGLE) {
                    <p class="field-description body-12-regular">{{ field.description }}</p>
                  }
                </div>
              }
            </div>
          </pdq-card>
        </form>
      } @else {
        <pdq-card variant="popover" color="white">
          <pdq-banner
            variant="attention"
            [closable]="false"
            bannerTitle="No editable settings"
            content="This extension does not expose a settings schema yet, so there is nothing to configure here.">
          </pdq-banner>
        </pdq-card>
      }

      <pdq-card variant="popover" color="white">
        <div class="card-title"><pdq-heading element="h5">Display Conditions</pdq-heading></div>
        <pdq-divider></pdq-divider>
        <div class="controls-wrapper">
          <span class="subtitle body-13-regular">This extension will only appear if:</span>
          <pdq-rules-dynamic-form
            [formGroup]="conditionsFormGroup"
            formArrayFieldName="restrictionsRules"
            [rules]="displayRules"
            [entities]="displayRulesEntities"
            [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
        </div>
      </pdq-card>
    }
  </div>
</div>
